
                  export default function (Component) {
                      Component.__source = "library/components/VabNotice/index.vue"
                  }
              